import { FC } from "react";
import { Link } from "@tanstack/react-router";
import type { NavigationItemProps } from "@tennr/frontend/components/Navigation";
import { DynamicText } from "@tennr/frontend/components/DynamicText";

export const NavigationLink: FC<NavigationItemProps> = ({
  item,
  active,
  disableDynamicText,
  className = "",
  onClick,
}) => (
  <>
    {item.to ? (
      <Link to={item.to} className={`nav-item ${active ? "active" : ""} ${className}`} onClick={onClick}>
        {disableDynamicText ? <span>{item.title}</span> : <DynamicText as="span">{item.title}</DynamicText>}
      </Link>
    ) : item.href ? (
      <a href={item.href} target="_blank" className={`nav-item ${className}`} onClick={onClick}>
        {disableDynamicText ? <span>{item.title}</span> : <DynamicText as="span">{item.title}</DynamicText>}
      </a>
    ) : undefined}
  </>
);
